





































import { Component, Emit, Prop } from 'vue-property-decorator';
import  CardForm from './CardForm.vue';
import  UiDialog  from '../Dialog';

@Component({
  components:{
    UiDialog
  }
})
export default class DialogForm extends CardForm {
  @Prop(Boolean)
  value!: boolean;

  @Prop(Boolean)
  toasts!: boolean;

  @Prop(Boolean)
  overlayMessage!: boolean;

  @Prop(Number)
  overlayOffset!: number;

  @Prop(String)
  contentClass!: string;

  @Prop(Number)
  width!: number;

  @Prop(Boolean)
  lazy!: boolean;

  @Emit('escape')
  onEscape() {}

  get height() {
    return `calc(100% - ${this.overlayOffset || 0}px - 8px)`;
  }

  get top() {
    return `${this.overlayOffset || 0}px`;
  }

  focus() {
    const dialog = this.$refs.dialog as UiDialog;
    dialog.focus();
  }

  default_slot: string = 'content';
}
